export default "__VITE_ASSET__DgpcdVZr__"